import styled from "styled-components";
import SHADOWS from "components/atoms/shadows";

export const Backdrop = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;

const Container = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: #fff;
  z-index: 101;
  transform: translate(-50%, -50%);
  box-shadow: ${SHADOWS.modal};
`;

const Large = styled(Container)`
  padding: 60px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow-y: auto;
`;

const Modal = {
  Container,
  Large,
};

export default Modal;
